import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_UNFILLED_RECOVERY: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainUnfilledRecovery($input: UpdateDomainUnfilledRecoveryInput!) {
    updateDomainUnfilledRecovery(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
